/**
 * Validation limits and constants
 */
// Room code configuration
export const ROOM_CODE_LENGTH = 4;
export const ROOM_CODE_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
// Validation Constants
export const USERNAME_MIN_LENGTH = 1;
export const USERNAME_MAX_LENGTH = 50;
export const MESSAGE_MAX_LENGTH = 1000;
// Game Manager Constants
export const MAX_ROOM_CODE_ATTEMPTS = 100;
export const GAME_EXPIRY_MS = 24 * 60 * 60 * 1000; // 24 hours
export const COMPLETED_GAME_EXPIRY_MS = 60 * 60 * 1000; // 1 hour
export const CLEANUP_INTERVAL_MS = 60 * 60 * 1000; // 1 hour
/** A finished game keeps its room code this long; an idle unfinished game is auto-abandoned after it. */
export const ROOM_CODE_HOLD_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
// Marco Polo Constants
export const MARCO_POLO_GRACE_PERIOD_SECONDS = 10;
// UI Constants
export const MEDALS = ['🥇', '🥈', '🥉'];
